Core.PortalCheckoutPayment = {
    init: function() {
        Core.PortalCheckoutPayment.Cache = {
            $radio: $('.toggle-radiogroup-content[name="checkoutPaymentMethod"]')
        };

        this.handleRadio();
        this.initCCInput();
        this.initTooltip();
        this.setBtnPaymentText($('.toggle-radiogroup-content[name="checkoutPaymentMethod"]:checked').val());
        Core.PortalCheckoutToggleRadioContent.handleRadioClick($('#divPayment .portal-radio__listbox-options-item'));
    },

    handleRadio: function() {
        var _self = Core.PortalCheckoutPayment;
        var _termConditionCheckbox = Core.PortalCheckoutTermsAndConditions;

        _self.Cache.$radio.on('change', function() {
            var $el = $(this),
                name = $el.attr("name"),
                $group = $('[data-content="' + name + '"]'),
                $target = $group.find($el.attr("data-target"));

            $termscondition = $el.attr("data-termscondition");
            $submittext = $el.attr("data-submittext");

            if ($termscondition == "False") {
                $(".portal-checkout__termsconditions").hide();
                $("#btnPayNow").removeClass('disabled').prop('disabled', false);
            }
            else {
                $(".portal-checkout__termsconditions").show();
                 if (!_termConditionCheckbox.isTermChecked()) {
                    $("#btnPayNow").removeClass('disabled').prop('disabled', true);
                 }
            }

            _self.setBtnPaymentText(this.value, $submittext);
            Core.PortalCheckoutToggleRadioContent.resetRadio($el);

            $group.find('.portal-checkout__radiogroup-item.active').removeClass('active');
            $target.addClass('active');
        });
    },

    setBtnPaymentText: function (payMethod, submitext) {
        var $btn = $("#btnPayNow");

        // https://levogroup.atlassian.net/browse/AD-462
        if (payMethod === "CreditCard") {
            $btn.text(submitext);
        } else {
            $btn.text(submitext);
        }

        // if(payMethod === "ChargeToAccount") {
        //     var roles = $('#userRole').val();

        //     if(!roles) {
        //         console.warn("Couldn't find '#userRole' element. Returned early.");
        //         return;
        //     }

        //     roles = roles.split(";");

        //     //https://levogroup.atlassian.net/browse/AD-137
        //     //check if only 'therapist'
        //     if(roles.length == 1 && roles[0] == 'Therapist') {
        //         btnText = "Send for Approval";
        //     }
        //     else if (roles.indexOf("Approver") != -1){
        //         btnText = "Submit Now";
        //     }
        // }

        //$("#btnPayNow").text(btnText);
    },

    initCCInput: function() {
        //console.log('init cc input');
        var cleave = new Cleave('#paymCCno', {
            creditCard: true,
            onCreditCardTypeChanged: function (type) {
                //console.log(type);
            }
        });
    },

    initTooltip: function() {
        $('#cvvTooltip').kendoTooltip({
            width: 200,
            position: "top",
            show: function(e) {
                this.popup.element.addClass('portal-tooltip text-center');
            }
        });
    },

    generateDummydata: function() {
        $('#checkoutPayment .portal-checkout__accordion-heading').on('dblclick', function() {
            $('#cardHolderName').val('Aidacare');
            $('#paymCCno').val('1234123412341234');
            $('#paymCCcvv').val('123');
            $("#paymentExpYear").data("kendoDropDownList").select(1);
            $("#paymentExpDate").data("kendoDropDownList").select(1);
        });

        $('#checkoutPayment .portal-checkout__accordion-content').on('dblclick', function() {
            $('#cardHolderName').val('Aidacare');
            $('#paymCCno').val('4564710000000004');
            $('#paymCCcvv').val('847');
            $("#paymentExpYear").data("kendoDropDownList").select(1);
            $("#paymentExpDate").data("kendoDropDownList").select(1);
        });
    }
};
